<template>
    <div 
        class="w-full group relative overflow-hidden h-220px md:h-auto" 
        style="aspect-ratio: 16/9;">
        
        <img 
            src='data:image/svg+xml;utf8,<svg fill-opacity="0" class="bg-black" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"></svg>'
            :data-src="src"
            class="w-full h-full object-center object-cover transform transition duration-500 group-hover:scale-110 lazyload"
            :alt="alt" />

         <div 
            class="w-full h-full absolute top-0"
            style="background: radial-gradient(transparent, #000); opacity: .9;"></div>

        <div 
            class="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center"
            :class="'hidden' === playbutton ? 'md:hidden' : ''">
            <svg 
                class=" text-mh-vid-red w-16 h-16"
                viewBox="0 0 50 50" 
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.534,37.374a1.774,1.774,0,0,1-.817-.2,1.813,1.813,0,0,1-.967-1.611V17.437a1.81,1.81,0,0,1,.967-1.61,1.774,1.774,0,0,1,.817-.2,1.756,1.756,0,0,1,1.035.336l12.493,9.063a1.828,1.828,0,0,1,0,2.95L21.57,37.039A1.759,1.759,0,0,1,20.534,37.374Z"
                    data-name="Subtraction 1" id="Subtraction_1" transform="translate(-0.75 -1.626)"
                    fill="#fff">
                </path>
                <path
                    d="M50,25A25,25,0,1,1,25,0,25,25,0,0,1,50,25ZM21.219,15.916a1.563,1.563,0,0,0-2.469,1.272V32.813a1.562,1.562,0,0,0,2.469,1.272l10.938-7.812a1.562,1.562,0,0,0,0-2.544L21.219,15.916Z"
                    fill="currentColor" id="play" transform="translate(0 0)"></path>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
        },
        alt: {
            type: String,
        },
        playbutton: {
            type: String,
            default: 'hidden',
        }
    }
}
</script>
